import keyMirror from 'keymirror'

export default keyMirror({
  //Authentication
  LOGIN_USER_REQUESTED: null,
  LOGIN_USER_FULFILLED: null,
  LOGIN_USER_REJECTED: null,
  AUTH_USER: null,
  UNAUTH_USER: null,
  GET_USER_BY_EMAIL_REQUESTED: null,
  GET_USER_BY_EMAIL_FULFILLED: null,
  GET_USER_BY_EMAIL_REJECTED: null,
  UPDATE_USER_PASSWORD_REQUESTED: null,
  UPDATE_USER_PASSWORD_FULFILLED: null,
  UPDATE_USER_PASSWORD_REJECTED: null,
  UPDATE_USER: null,
  RESET_PASSWORD_REQUESTED: null,
  RESET_PASSWORD_FULFILLED: null,
  RESET_PASSWORD_REJECTED: null,
  AUTH_MEMBER_REQUESTED: null,
  AUTH_MEMBER_REJECTED: null,
  AUTH_MEMBER_FULFILLED: null,
  SET_USER: null,
  SET_PROVIDER_LIST: null,
  ADD_USER_ACTIVITY_REQUESTED: null,
  ADD_USER_ACTIVITY_REJECTED: null,
  ADD_USER_ACTIVITY_FULFILLED: null,
  //User Account
  GET_USERS_REQUESTED: null,
  GET_USERS_FULFILLED: null,
  GET_USERS_REJECTED: null,
  ADD_USER_REQUESTED: null,
  ADD_USER_FULFILLED: null,
  ADD_USER_REJECTED: null,
  UPDATE_USER_REQUESTED: null,
  UPDATE_USER_REJECTED: null,
  UPDATE_USER_FULFILLED: null,
  GET_ROLES_REQUESTED: null,
  GET_ROLES_REJECTED: null,
  GET_ROLES_FULFILLED: null,
  GET_PROVIDERS_REQUESTED: null,
  GET_PROVIDERS_REJECTED: null,
  GET_PROVIDERS_FULFILLED: null,
  SET_SELECTED_PROVIDER: null,
  SET_ORGANIZATION_VIEW: null,
  VALIDATE_PROVIDER_ADMIN_USER_REQUESTED: null,
  VALIDATE_PROVIDER_ADMIN_USER_FULFILLED: null,
  VALIDATE_PROVIDER_ADMIN_USER_REJECTED: null,
  SHOW_ORGANIZATION_MODAL: null,
  SET_SELECTED_ORGANIZATION: null,
  //Authorizations
  GET_AUTHORIZATIONS_REQUESTED: null,
  GET_AUTHORIZATIONS_FULFILLED: null,
  GET_AUTHORIZATIONS_REJECTED: null,
  GET_ORG_AUTHORIZATIONS_REQUESTED: null,
  GET_ORG_AUTHORIZATIONS_FULFILLED: null,
  GET_ORG_AUTHORIZATIONS_REJECTED: null,
  CLEAR_CSV_AUTHORIZATIONS: null,
  //Claims
  GET_CLAIMS_REQUESTED: null,
  GET_CLAIMS_FULFILLED: null,
  GET_CLAIMS_REJECTED: null,
  GET_ORG_CLAIMS_REQUESTED: null,
  GET_ORG_CLAIMS_FULFILLED: null,
  GET_ORG_CLAIMS_REJECTED: null,
  CLEAR_CSV_CLAIMS: null,
  //Rates
  GET_SERVICES_REQUESTED: null,
  GET_SERVICES_FULFILLED: null,
  GET_SERVICES_REJECTED: null,
  //Audits
  GET_PROVIDER_AUDITS_AND_VERIFICATIONS_REQUESTED: null,
  GET_PROVIDER_AUDITS_AND_VERIFICATIONS_REJECTED: null,
  GET_PROVIDER_AUDITS_AND_VERIFICATIONS_FULFILLED: null,
  GET_PROVIDER_FILE_AUDITS_REQUESTED: null,
  GET_PROVIDER_FILE_AUDITS_REJECTED: null,
  GET_PROVIDER_FILE_AUDITS_FULFILLED: null,
  //Mail
  SEND_MAIL_REQUESTED: null,
  SEND_MAIL_FULFILLED: null,
  SEND_MAIL_REJECTED: null,
  //RESOURCES
  GET_RESOURCES_REQUESTED: null,
  GET_RESOURCES_FULFILLED: null,
  GET_RESOURCES_REJECTED: null,
  //NEWS_UPDATES
  GET_NEWS_UPDATES_REQUESTED: null,
  GET_NEWS_UPDATES_FULFILLED: null,
  GET_NEWS_UPDATES_REJECTED: null,
  GET_ANNOUNCEMENT_REQUESTED: null,
  GET_ANNOUNCEMENT_FULFILLED: null,
  GET_ANNOUNCEMENT_REJECTED: null,
  GET_NEWS_UPDATES_BY_ORGANIZATION_REQUESTED: null,
  GET_NEWS_UPDATES_BY_ORGANIZATION_FULFILLED: null,
  GET_NEWS_UPDATES_BY_ORGANIZATION_REJECTED: null,
  //DROPDOWNS
  GET_SERVICE_TYPES_REQUESTED: null,
  GET_SERVICE_TYPES_FULFILLED: null,
  GET_SERVICE_TYPES_REJECTED: null,
  GET_CITIES_REQUESTED: null,
  GET_CITIES_FULFILLED: null,
  GET_CITIES_REJECTED: null,
  GET_STATES_REQUESTED: null,
  GET_STATES_FULFILLED: null,
  GET_STATES_REJECTED: null,
  GET_COUNTIES_REQUESTED: null,
  GET_COUNTIES_FULFILLED: null,
  GET_COUNTIES_REJECTED: null,
  GET_TARGET_GROUPS_REQUESTED: null,
  GET_TARGET_GROUPS_FULFILLED: null,
  GET_TARGET_GROUPS_REJECTED: null,
  GET_ACCESSIBILITIES_REQUESTED: null,
  GET_ACCESSIBILITIES_FULFILLED: null,
  GET_ACCESSIBILITIES_REJECTED: null,
  GET_LANGUAGES_REQUESTED: null,
  GET_LANGUAGES_FULFILLED: null,
  GET_LANGUAGES_REJECTED: null,
  GET_APPLICATION_WELCOME_ALERT_REQUESTED: null,
  GET_APPLICATION_WELCOME_ALERT_FULFILLED: null,
  GET_APPLICATION_WELCOME_ALERT_REJECTED: null,
  GET_WAVIER_COMPLIANT_REQUESTED: null,
  GET_WAVIER_COMPLIANT_FULFILLED: null,
  GET_WAVIER_COMPLIANT_REJECTED: null,
  GET_TRANSPORTATION_REQUESTED: null,
  GET_TRANSPORTATION_REJECTED: null,
  GET_TRANSPORTATION_FULFILLED: null,
  GET_OVERNIGHT_CARE_REQUESTED: null,
  GET_OVERNIGHT_CARE_REJECTED: null,
  GET_OVERNIGHT_CARE_FULFILLED: null,
  GET_STAFFING_MODEL_REQUESTED: null,
  GET_STAFFING_MODEL_REJECTED: null,
  GET_STAFFING_MODEL_FULFILLED: null,
  GET_ETHNICITY_REQUESTED: null,
  GET_ETHNICITY_REJECTED: null,
  GET_ETHNICITY_FULFILLED: null,
  GET_RACE_REQUESTED: null,
  GET_RACE_REJECTED: null,
  GET_RACE_FULFILLED: null,
  //Application Process Authentication
  ADD_APP_PROCESS_USER_REQUESTED: null,
  ADD_APP_PROCESS_USER_FULFILLED: null,
  ADD_APP_PROCESS_USER_REJECTED: null,
  VALIDATE_USER_REQUESTED: null,
  VALIDATE_USER_FULFILLED: null,
  VALIDATE_USER_REJECTED: null,
  //Provider Application
  GET_PROVIDER_APPLICATION_REQUESTED: null,
  GET_PROVIDER_APPLICATION_FULFILLED: null,
  GET_PROVIDER_APPLICATION_REJECTED: null,
  ADD_PROVIDER_APPLICATION_REQUESTED: null,
  ADD_PROVIDER_APPLICATION_FULFILLED: null,
  ADD_PROVIDER_APPLICATION_REJECTED: null,
  UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_REQUESTED: null,
  UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_FULFILLED: null,
  UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_REJECTED: null,
  UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_REQUESTED: null,
  UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_FULFILLED: null,
  UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_REJECTED: null,
  UPDATE_PROVIDER_APPLICATION_ORG_INFO_REQUESTED: null,
  UPDATE_PROVIDER_APPLICATION_ORG_INFO_FULFILLED: null,
  UPDATE_PROVIDER_APPLICATION_ORG_INFO_REJECTED: null,
  UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_REQUESTED: null,
  UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_FULFILLED: null,
  UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_REJECTED: null,
  UPDATE_PROVIDER_APPLICATION_ITEM_REQUESTED: null,
  UPDATE_PROVIDER_APPLICATION_ITEM_FULFILLED: null,
  UPDATE_PROVIDER_APPLICATION_ITEM_REJECTED: null,
  UPDATE_PROVIDER_APPLICATION_CERTIFICATION_REQUESTED: null,
  UPDATE_PROVIDER_APPLICATION_CERTIFICATION_FULFILLED: null,
  UPDATE_PROVIDER_APPLICATION_CERTIFICATION_REJECTED: null,
  SUBMIT_PROVIDER_APPLICATION_REQUESTED: null,
  SUBMIT_PROVIDER_APPLICATION_FULFILLED: null,
  SUBMIT_PROVIDER_APPLICATION_REJECTED: null,
  SUBMIT_CERTIFICATION_ITEMS_REQUESTED: null,
  SUBMIT_CERTIFICATION_ITEMS_FULFILLED: null,
  SUBMIT_CERTIFICATION_ITEMS_REJECTED: null,
  //Location Application
  GET_LOCATION_APPLICATIONS_REQUESTED: null,
  GET_LOCATION_APPLICATIONS_FULFILLED: null,
  GET_LOCATION_APPLICATIONS_REJECTED: null,
  GET_LOCATION_APPLICATION_REQUESTED: null,
  GET_LOCATION_APPLICATION_FULFILLED: null,
  GET_LOCATION_APPLICATION_REJECTED: null,
  ADD_LOCATION_APPLICATION_REQUESTED: null,
  ADD_LOCATION_APPLICATION_FULFILLED: null,
  ADD_LOCATION_APPLICATION_REJECTED: null,
  ADD_LOCATION_APPLICATION_RESET: null,
  UPDATE_LOCATION_APPLICATION_GENERAL_INFO_REQUESTED: null,
  UPDATE_LOCATION_APPLICATION_GENERAL_INFO_FULFILLED: null,
  UPDATE_LOCATION_APPLICATION_GENERAL_INFO_REJECTED: null,
  UPDATE_LOCATION_APPLICATION_CONTACT_INFO_REQUESTED: null,
  UPDATE_LOCATION_APPLICATION_CONTACT_INFO_FULFILLED: null,
  UPDATE_LOCATION_APPLICATION_CONTACT_INFO_REJECTED: null,
  UPDATE_LOCATION_APPLICATION_ORG_INFO_REQUESTED: null,
  UPDATE_LOCATION_APPLICATION_ORG_INFO_FULFILLED: null,
  UPDATE_LOCATION_APPLICATION_ORG_INFO_REJECTED: null,
  UPDATE_LOCATION_APPLICATION_DISCLOSURE_QUESTIONS_REQUESTED: null,
  UPDATE_LOCATION_APPLICATION_DISCLOSURE_QUESTIONS_FULFILLED: null,
  UPDATE_LOCATION_APPLICATION_DISCLOSURE_QUESTIONS_REJECTED: null,
  UPDATE_LOCATION_APPLICATION_ITEM_REQUESTED: null,
  UPDATE_LOCATION_APPLICATION_ITEM_FULFILLED: null,
  UPDATE_LOCATION_APPLICATION_ITEM_REJECTED: null,
  UPDATE_LOCATION_APPLICATION_CERTIFICATION_REQUESTED: null,
  UPDATE_LOCATION_APPLICATION_CERTIFICATION_FULFILLED: null,
  UPDATE_LOCATION_APPLICATION_CERTIFICATION_REJECTED: null,
  SUBMIT_LOCATION_APPLICATION_REQUESTED: null,
  SUBMIT_LOCATION_APPLICATION_FULFILLED: null,
  SUBMIT_LOCATION_APPLICATION_REJECTED: null,
  SUBMIT_LOCATION_CERTIFICATION_ITEMS_REQUESTED: null,
  SUBMIT_LOCATION_CERTIFICATION_ITEMS_FULFILLED: null,
  SUBMIT_LOCATION_CERTIFICATION_ITEMS_REJECTED: null,
  //Care Plan
  GET_CARE_PLAN_TO_SIGN_REQUESTED: null,
  GET_CARE_PLAN_TO_SIGN_FULFILLED: null,
  GET_CARE_PLAN_TO_SIGN_REJECTED: null,
  GET_CARE_PLAN_GRID_REQUESTED: null,
  GET_CARE_PLAN_GRID_FULFILLED: null,
  GET_CARE_PLAN_GRID_REJECTED: null,
  UPDATE_PROVIDER_ACKNOWLEDGE_REQUESTED: null,
  UPDATE_PROVIDER_ACKNOWLEDGE_REJECTED: null,
  UPDATE_PROVIDER_ACKNOWLEDGE_FULFILLED: null,
  //Provider File Audit
  UPDATE_PROVIDER_FILE_AUDIT_ITEM_REQUESTED: null,
  UPDATE_PROVIDER_FILE_AUDIT_ITEM_REJECTED: null,
  UPDATE_PROVIDER_FILE_AUDIT_ITEM_FULFILLED: null,
  SET_SELECTED_PROVIDER_FILE_AUDIT: null,
  // Background Check Verification
  GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_REQUESTED: null,
  GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_FULFILLED: null,
  GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_REJECTED: null,
  UPDATE_BACKGROUND_CHECK_VERIFICATION_REQUESTED: null,
  UPDATE_BACKGROUND_CHECK_VERIFICATION_FULFILLED: null,
  UPDATE_BACKGROUND_CHECK_VERIFICATION_REJECTED: null,
  UPLOADED_BACKGROUND_CHECK_VERIFICATION_ATTACHMENT: null,
  // Service Verification Audit
  GET_SERVICE_VERIFICATION_AUDIT_BY_ID_REQUESTED: null,
  GET_SERVICE_VERIFICATION_AUDIT_BY_ID_FULFILLED: null,
  GET_SERVICE_VERIFICATION_AUDIT_BY_ID_REJECTED: null,
  UPDATE_SERVICE_VERIFICATION_AUDIT_REQUESTED: null,
  UPDATE_SERVICE_VERIFICATION_AUDIT_FULFILLED: null,
  UPDATE_SERVICE_VERIFICATION_AUDIT_REJECTED: null,
  //Provider Detail
  GET_PROVIDER_DETAIL_REQUESTED: null,
  GET_PROVIDER_DETAIL_REJECTED: null,
  GET_PROVIDER_DETAIL_FULFILLED: null,
  GET_ORG_PROVIDER_DETAIL_REQUESTED: null,
  GET_ORG_PROVIDER_DETAIL_REJECTED: null,
  GET_ORG_PROVIDER_DETAIL_FULFILLED: null,
  UPDATE_PROVIDER_DETAIL_REQUESTED: null,
  UPDATE_PROVIDER_DETAIL_FULFILLED: null,
  UPDATE_PROVIDER_DETAIL_REJECTED: null,
  GET_DETAIL_TO_UPDATE_REQUESTED: null,
  GET_DETAIL_TO_UPDATE_FULFILLED: null,
  GET_DETAIL_TO_UPDATE_REJECTED: null,
})
